import { defineComponent as a, openBlock as n, createBlock as o, resolveDynamicComponent as l, withCtx as r, createElementVNode as s, renderSlot as c } from "vue";
const i = {
  class: "max-w-full grow px-24 lg:max-w-[1184px] lg:basis-full lg:px-32",
  "data-test": "container-wrapper"
}, f = /* @__PURE__ */ a({
  name: "RevContainer",
  __name: "Container",
  props: {
    as: { default: "div" }
  },
  setup(e) {
    return (t, p) => (n(), o(l(e.as), { class: "flex justify-center" }, {
      default: r(() => [
        s("div", i, [
          c(t.$slots, "default")
        ])
      ]),
      _: 3
    }));
  }
});
export {
  f as default
};
